import {applyMiddleware, compose, legacy_createStore as createStore} from "redux";
import reduxLogger from "redux-logger";
import createSagaMiddleware from "redux-saga";
import AppReducers from "./Reducers";
import allSagas from "./Sagas/root";

import {persistReducer, persistStore} from "redux-persist";
// Defaults to SessionStorage
import sessionStorage from "redux-persist/es/storage/session";

const middleWares = [];

/* eslint-disable */
if (1) {
  middleWares.push(reduxLogger);
}

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  // cloneProfile manages its own localStorage-backed persistence (see
  // cloneProfile.reducer.js) so it can survive a reload with taskId/
  // targetMac restored but progress reset to 0/0. Also persisting it here
  // would let redux-persist's REHYDRATE clobber that reset with a stale
  // snapshot right after mount.
  blacklist: ["cloneProfile"],
};

const persistedReducer = persistReducer(persistConfig, AppReducers);
const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  middleWares.push(sagaMiddleware);

  const allMiddleWares = compose(applyMiddleware(...middleWares));
  const store = createStore(persistedReducer, allMiddleWares);
  let persistor = persistStore(store);

  //Running all Worker Sagas
  sagaMiddleware.run(allSagas);

  return {store, persistor};
};

export default configureStore;
